import ContactsContainer from "../../../Components/Applications/Contacts/ContactsContainer";

const Contacts = () => {
  return <ContactsContainer />;
};

export default Contacts;
